/*
 *                       NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *           UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 *     This program is confidential and a trade secret of Ab Initio.
 *     The receipt or possession of this program does not convey any
 *     rights to reproduce or disclose its contents, or to manufacture,
 *     use or sell anything that it may describe, in whole or in part,
 *     without the specific written consent of Ab Initio.
 */

import { ErrorExtra, ErrorUtils } from "abweb/utils/ErrorUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
const LOG = LogUtils.getLogger(__filename);

/**
 * Logs error, which causes it to render in the console as well as being logged so that
 * it is available in a PFS.
 */
export class ErrorContextLogger {
  handleErrorContext(errCtx) {
    if (!errCtx) {
      return; // defensive
    }
    let msg;
    // If error is NestedError, then errCtx.error implicitly is errCtx.error.toString() which gives causal message chain
    let errOut = errCtx.error ? "" + errCtx.error : "";
    if (errCtx.moduleInfo) {
      // Thrown by task queue (ui thread), as only those exception events (ErrorEvent) contain module info.
      const modInfo = errCtx.moduleInfo;
      msg = `Unhandled error: '${errOut}', ` + `\n\tSource: '${modInfo.filename}:${modInfo.lineno}:${modInfo.colno}'`;
      // console.error(`${new Date().getTime()} appErrorEventHandler(msg: '${event.message}', source: '${event.filename}', `
      //     + `lineno: '${event.lineno}', colno: '${event.colno}', error: '${event.error}', `
      //     + `ev.defaultPrevented='${event.defaultPrevented}, ev.bubbles='${event.bubbles}, ev.returnValue='${event.returnValue}'`);
    } else {
      // AFAIK, only promise errors do not have the moduleInfo
      msg = `Unhandled promise chain error: '${errOut}')`;
    }

    // ABSDK-478: log error extras
    for (const extra of Object.values(ErrorExtra)) {
      const value = ErrorUtils.getErrorExtra(errCtx.error, extra);
      if (value) {
        msg += "\n" + extra.toString() + ": " + value;
      }
    }

    // For PFS diagnostic support it is really helpful to log the actual runtime stack where the error was thrown
    // Known issue: the raw stack outputs the js line numbers, and in production the url for each stack entry will be a bundle...
    // However, it does list the class.method for each stack entry, which is helpful (e.g., ErrorDiscoverView.render)
    // Note that the errCtx.error.stack format can also vary by browser,
    // and no attempt is made (yet) to normalize the format across browsers

    // ABSDK-1781: An Error logs much better when it's alone. So log the message and then error separately.
    LOG.error(msg);
    if (errCtx.error) {
      // "any" because Aurelia wants a string, but errCtx.error has a toString() method, which is good enough.
      LOG.error(errCtx.error);
    }
  }
}

/*
  * Example error output:
ERROR 2018-06-21T20:07:12.000Z [  ErrorContextLogger] Unhandled promise chain error: 'Error: Throw in onClick callback'),
  Stack: Error: Throw in onClick callback
    at ErrorDiscoveryView.eval (http://localhost:8321/abreactTest/spa/webapp/ui/samplers/errorDiscovery/ErrorDiscoveryView.js:90:43)
    at step (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:147:11874)
    at Object.eval [as next] (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:147:11179)
    at eval (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:147:11090)
    at new Promise (<anonymous>)
    at Module.__awaiter (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:147:10703)
    at Object.onClick (http://localhost:8321/abreactTest/spa/webapp/ui/samplers/errorDiscovery/ErrorDiscoveryView.js:88:184)
    at apply (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:142:25911)
    at baseInvoke (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:135:23089)
    at apply (http://localhost:8321/abreactTest/spa/webapp/ext-3.3.5.0-ace-bre-3-3-expressit-SNAPSHOT-180614214025.min.js:142:25960) [http://localhost:8321/abreactTest/spa/webapp/abweb/utils/error/ErrorResolver.js:44:41] */
//# sourceMappingURL=ErrorContextLogger.js.map
